import { render, staticRenderFns } from "./BlackGoldSignupModal.vue?vue&type=template&id=78280ebc"
import script from "./BlackGoldSignupModal.vue?vue&type=script&lang=js"
export * from "./BlackGoldSignupModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports